import Login from '../components/Login';
import Register from '../components/Register.vue';
import ForgotPassword from '../components/ForgotPassword.vue';
import ResetPassword from '../components/ResetPassword.vue';
import WelcomePage from '../components/WelcomePage.vue';
import InvitePage from '../designer/components/InvitePage.vue';

const authRoutes = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            guest: true,
        },
    },

    {
        path: '/forgot-password',
        component: ForgotPassword,
        name: 'forgot-password',
        meta: {
            guest: true,
        },
    },

    {
        path: '/password/reset',
        component: ResetPassword,
        name: 'resetpassword',
        meta: {
            guest: true,

        },
    },
    {
        path: '/invite/:code',
        component: InvitePage,
        name: 'invite',
        meta: {
            guest: true,
            auth: true,
        },
    }
];

if (window.IS_LITE_VERSION) {
    authRoutes.push({
        path: '/register',
        component: Register,
        name: 'register',
        meta: {
            guest: true,
        },
    });
    authRoutes.push({
        path: '/welcome',
        component: WelcomePage,
        name: 'welcome',
        meta: {
            auth: true,

        },
    });
}

export default authRoutes;
